export const createLogger = (service: string, color: string, fontWeight: 'normal' | 'bold' = 'bold', devOnly = false): LoggerInterface => {
  if (devOnly && BUILD_MODE !== 'dev') {
    return new EmptyLogger()
  }
  return new Logger(service, color, fontWeight)
}

type LoggerInterface = {
  log: (...args: any[]) => void
  props: (label: string, props: Record<string, any>) => void
  withPrefix: (prefix: string) => LoggerInterface
}

class Logger extends Function implements LoggerInterface {
  service: string
  prefix: string
  color: string
  fontWeight: 'normal' | 'bold'
  devOnly: boolean

  constructor(service: string, color: string, fontWeight: 'normal' | 'bold' = 'bold', devOnly: boolean = false) {
    super()
    this.prefix = ''
    this.service = service
    this.color = color
    this.fontWeight = fontWeight
    this.devOnly = devOnly
  }

  log = (...args: any[]) => {
    if (!IS_BROWSER) {
      if (process.env.NODE_ENV === 'production') {
        console.info(JSON.stringify(this.toJsonEntry(args)))
        return
      }
      const time = `[${new Date().toISOString().substring(11, 11 + 12)}]`
      console.info(time, this.prefix, `[${this.service}]`, ...args)
      return
    }
    if (this.prefix) {
      args = [this.prefix, ...args]
    }
    console.info(`%c[${this.service}]`, `color: ${this.color}; font-weight: ${this.fontWeight};`, ...args)
  }

  props(label: string, props: Record<string, any>) {
    const strprops = Object.entries(props)
      .map(([k, v]) => `${k}: ${typeof v === 'object' ? JSON.stringify(v) : v}`)
      .join(', ')
    this.log(`${label},`, strprops)
  }

  withPrefix(prefix: string) {
    const logger = new Logger(this.service, this.color, this.fontWeight, this.devOnly)
    logger.prefix = prefix ? `${prefix}` : ''
    return logger
  }

  private toJsonEntry(args: any[]): Record<string, unknown> {
    const entry: Record<string, unknown> = {
      timestamp: new Date().toISOString(),
      level: 'info',
      service: this.service,
    }
    if (this.prefix) entry.prefix = this.prefix
    if (args.length === 1) {
      entry.message = args[0]
    } else if (args.length > 1) {
      entry.message = args[0]
      entry.args = args.slice(1)
    }
    return entry
  }
}

class EmptyLogger implements LoggerInterface {
  constructor() {}
  log = () => {}
  props() {}
  withPrefix() {
    return this
  }
}
